function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b29ac764-bcc7-43e0-861f-e8232203b51a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M62.53,0C51.4,1.53,41.1,3,30.45,4.43V30H62.53Z",
    style: {
      fill: "#5cb2e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47,54.39c8.68,1.25,17.12,2.68,25.55,3.89V32.76H1.47Z",
    style: {
      fill: "#5cb2e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.53,32.63H30.45V58.82C41.2,60.53,51.58,62.25,62.53,64Z",
    style: {
      fill: "#5cb2e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47,8.21V30H27.3V4.93Z",
    style: {
      fill: "#5cb2e4"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.69b5cf3cdab0d0eafcd173f77c6cf12b.svg";
export { ForwardRef as ReactComponent };